export default {
  LOAD_USER_JWT (state, payload) {
    state.userJwt = payload
  },
  LOAD_IS_CHANNEL_READY (state, payload) {
    state.isChannelReady = payload
  },
  LOAD_UNREAD_VALUE (state, payload) {
    state.unreadValue = payload
  },
  LOAD_IS_CHANNEL_WINDOW_CLOSED (state, payload) {
    state.isChannelWindowClosed = payload
  },
  LOAD_ALL_CHANNELS (state, payload) {
    state.channels = payload
  },
  LOAD_CHANNEL_DETAIL (state, payload) {
    state.channelDetail = payload
  },
  LOAD_CHANNEL_UNREAD_COUNT (state, payload) {
    state.channelUnreadCount[payload.channelId] = payload.unread
    let count = 0
    for (const key in state.channelUnreadCount) {
      count += state.channelUnreadCount[key]
    }
    state.unreadCountState = count
  },
  LOAD_CHANNEL_UNREAD_RECOMPUTE (state, payload) {
    state.channelUnreadCount['recompute'] = payload
  },
  LOAD_SELECTED_CHANNEL (state, payload) {
    state.selectedChannel = payload
  },
  LOAD_CUSTOM_BAD_WORDS (state, payload) {
    state.customBadWords = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/channel/vuex/mutations.js